import React from 'react'
import styles from '../DataRow.less'
import _ from 'common-tools/LodashHelper'

export class DataRowFieldsLine extends React.Component {
  render () {
    const { fields } = this.props

    return (
      <div className={styles.cardFlexRow} >
        {_.map(fields, (f, i) => {
          let className = i === 0 ? styles.cardInfoColumnNoMargin : styles.cardInfoColumn
          return <div className={className}>
            <div className={styles.cardInfoColumnTitle}>{f.text}</div>
            <div className={styles.cardInfoColumnText} dangerouslySetInnerHTML={{ __html: f.value }}></div>
          </div>
        })}
      </div>
    )
  }
}
